import { GzCompanyFilterWebComponent } from '../../../../ui/gzCompanyFilter';
import { SelectedOption } from '../../../../ui/gzEnumList/types';

export class IncidentsItems {
  static getExtraFilters(): Array<any> {
    const extraFilters: any = [];

    const companyFilterComponent = document
      .querySelector('gz-incidents-grid')
      ?.shadowRoot?.querySelector('gz-grid-view')
      ?.shadowRoot?.querySelector('gz-grid-filters')
      ?.shadowRoot?.querySelector('gz-company-filter') as GzCompanyFilterWebComponent;

    if (!companyFilterComponent) {
      return [];
    }

    const companyFilterValues = companyFilterComponent.enumList.getCheckedOptions();

    if (companyFilterValues.length === 0) {
      return [];
    }

    const companyIds = companyFilterValues.map((item: SelectedOption) => {
      return item.value;
    });

    if (companyIds.includes('all')) {
      return [];
    }

    return [
      {
        property: 'company.id',
        value: companyIds,
      },
    ];
  }
}
